export const mapToArray = (map) => Array.from(map.values());
